import { NextPage } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { GetServerSidePropsContext } from "next";
import StrategyKM7 from "components/pages/strategy/KM7";

interface Props {}

const StrategyKM7Page: NextPage<Props> = ({}) => {
  return <StrategyKM7 />;
};
export default StrategyKM7Page;

export async function getServerSideProps(context: GetServerSidePropsContext) {
  let locale = context.locale || context.defaultLocale || "ko";

  return {
    props: {
      ...(await serverSideTranslations(locale, ["strategy"])),
    },
  };
}
